var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UserMenu'),_c('div',{staticClass:"page"},[_c('header',[_vm._t("header")],2),_c('main',[_vm._t("main")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }